module.exports = __webpack_public_path__ + "babf1bf78bcd6aae0ecd8fedb89d88ef.pdf";